import React from "react";
import { 
  FaBed, FaLock, FaSnowflake, FaThermometerHalf, FaTshirt, 
  FaHotTub, FaTint, FaFire, FaWater, FaMicrophone, FaWifi, 
  FaBroom, FaDesktop, FaChair, FaCheckCircle, FaFileAlt, FaIdCard
} from "react-icons/fa";
import "../css/Amenities.css";

export default function Amenities() {
  const amenitiesList = [
    { icon: <FaBed />, name: "Bed" },
    { icon: <FaLock />, name: "Cupboard" },
    { icon: <FaSnowflake />, name: "Air conditioner" },
    { icon: <FaThermometerHalf />, name: "Fridge" },
    { icon: <FaTshirt />, name: "Washing Machine" },
    { icon: <FaHotTub />, name: "Geyser" },
    { icon: <FaTint />, name: "Aqua guard" },
    { icon: <FaFire />, name: "Gas Stove" },
    { icon: <FaWater />, name: "24 hours Water" },
    { icon: <FaMicrophone />, name: "Microwave Oven" },
    { icon: <FaWifi />, name: "WiFi" },
    { icon: <FaBroom />, name: "Housekeeping" },
    { icon: <FaDesktop />, name: "Study table" },
    { icon: <FaChair />, name: "Chair" }
  ];

  return (
    <section className="amenities-section-premium">
      <div className="amenities-premium-header">
        <div className="amenities-premium-badge">💁‍♀️ Premium Amenities</div>
        <h2>Everything You <span className="amenities-gradient-text">Need, Included</span></h2>
        <p>
          Experience hassle-free living with our comprehensive range of amenities, 
          thoughtfully curated for your comfort and convenience.
        </p>
      </div>

      <div className="amenities-premium-grid">
        {amenitiesList.map((item, index) => (
          <div key={index} className="amenities-premium-card">
            <div className="amenities-premium-icon">
              {item.icon}
            </div>
            <h3 className="amenities-premium-title">{item.name}</h3>
          </div>
        ))}
      </div>

      {/* All Included Badge */}
      <div className="amenities-all-included">
        <div className="all-included-badge">
          <FaCheckCircle />
          <span>All Included</span>
          {/* <span className="smiley">👍</span> */}
        </div>
      </div>

      {/* Agreement & Police Verification Section */}
      <div className="amenities-agreement-section">
        <div className="agreement-card">
          <div className="agreement-icon">
            <FaFileAlt />
          </div>
          <div className="agreement-content">
            <h4>📝 Agreement</h4>
            {/* <p>11 Month Agreement with 1 Month Deposit</p> */}
          </div>
        </div>
        <div className="agreement-card police-card">
          <div className="agreement-icon">
            <FaIdCard />
          </div>
          <div className="agreement-content">
            <h4>🔎 Police Verification</h4>
            {/* <p>Required (Aadhar Card & PAN Card) - Extra</p> */}
          </div>
        </div>
      </div>
    </section>
  );
}